import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["reverse", "round", "view", "className"];
import React from 'react';
import { cnBem } from '@carnica/utils';
import { SkeletonBrick } from "../../Skeleton";
import styles from "./styles.pcss";
import { Avatar } from "../Avatar";
var cnCell = cnBem('skeleton-cell', styles);
export var Cell = function Cell(_ref) {
  var reverse = _ref.reverse,
    round = _ref.round,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? 'default' : _ref$view,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnCell({
      view: view,
      round: round
    }, [className])
  }, props), /*#__PURE__*/React.createElement(Avatar, {
    size: "m"
  }), /*#__PURE__*/React.createElement("div", {
    className: cnCell('wrapper', {
      reverse: reverse
    })
  }, /*#__PURE__*/React.createElement(SkeletonBrick, {
    height: 24,
    width: "100%"
  }), /*#__PURE__*/React.createElement(SkeletonBrick, {
    height: 16,
    width: 160
  })));
};